
import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import IphoneMock from "../assets/images/iPhone14.png";
import ChooseUs from "../assets/images/chooseUs.jpg";
import ChooseUsIcon from "../assets/images/chooseUsIcon.png";
import MainIcon from "../assets/images/Bildup-Icon.png";


const TutorFeatureCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const carouselRef = useRef(null);

  // Carousel data
  const carouselData = [
    {
      id: 1,
      title: "Cost Effectiveness",
      description: "Potentially more affordable than ongoing private tutoring",
      icon: "mdi:currency-usd",
      color: "bg-purple-100",
      iconColor: "text-purple-600",
      topText: "Potentially more affordable than ongoing private tutoring",
      bottomText: "Can be a significant ongoing expense",
    },
    {
      id: 2,
      title: "Personalization",
      description:
        "Adapts to your child's learning pace and needs across subjects",
      icon: "mingcute:target-line",
      color: "bg-blue-100",
      iconColor: "text-blue-600",
      topText: "Adapts to your child's learning pace and needs across subjects",
      bottomText: "May follow a more general approach",
    },
    {
      id: 3,
      title: "Patience",
      description: "Prepare for exams in BECE, WASSCE, NECO, JAMB and more!",
      icon: "mage:light-bulb",
      color: "bg-indigo-100",
      iconColor: "text-indigo-600",
      topText: "Unlimited patience, explains concepts as many times as needed",
      bottomText: "Can Vary",
    },
    {
      id: 4,
      title: "24/7 Availability",
      description: "Access learning support anytime, anywhere.",
      icon: "mdi:clock-outline",
      color: "bg-teal-100",
      iconColor: "text-teal-600",
      topText: "24/7 access, learn anytime, anywhere",
      bottomText: "Limited by scheduling",
    },
    {
      id: 5,
      title: "Feedback",
      description: "Access learning support anytime, anywhere.",
      icon: "material-symbols:feedback",
      color: "bg-teal-100",
      iconColor: "text-teal-600",
      topText:
        "Instant feedback and identification of areas for improvement in any subject",
      bottomText: "May not always be immediate",
    },
    {
      id: 6,
      title: "Pressure/Judgement",
      description: "Access learning support anytime, anywhere.",
      icon: "fluent-emoji-high-contrast:fearful-face",
      color: "bg-teal-100",
      iconColor: "text-teal-600",
      topText: "Creates a safe and encouraging learning environment",
      bottomText: "Can sometimes feel intimidating for struggling students",
    },
  ];

  const handleNext = () => {
    setActiveIndex((prev) => (prev === carouselData.length - 1 ? 0 : prev + 1));
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? carouselData.length - 1 : prev - 1));
  };

  // Auto-play functionality
  useEffect(() => {
    const interval = setInterval(() => {
      if (document.hasFocus()) {
        handleNext();
      }
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [activeIndex]);

  return (
    <section className="py-0 px-4 overflow-hidden">
      <div className="max-w-screen-xl mx-auto">
        <div className="md:flex items-center gap-x-10 md:h-[50vh] ">
          {/* Left column - Static info */}

          <div className="md:w-[50%] mb-10 md:mb-0 h-full rounded-2xl shadow-lg border  ">
            <div className="light-main p-6 rounded-xl shadow-md h-full flex flex-col items-center justify-center">
              <p className="text-primary-purple-200 md:mb-6 md:text-[20px] text-[18px] text-center">
                Our super-intelligent AI personal tutor is designed to support
                success across Nigerian and British curricula, ensuring students
                excel globally, while studying locally.
              </p>

              

              <p className="text-primary-purple-100 md:text-[20px] text-[18px] mt-10 md:mt-0  text-center">
                With your child's future in mind, we've tailored our AI
                tutor/teacher to offer learning resources for additional
                international curriculum, providing exposure to diverse
                perspectives and opportunities.
              </p>
            </div>
          </div>

          {/* Right column - Carousel with phone mockup background */}
          <div className="md:w-[50%] relative overflow-hidden h-full rounded-2xl">
          <div className="relative h-full">
                <div className="mb-6 h-full">
                  <img
                    src={ChooseUs}
                    alt="Student learning"
                    className="rounded-lg w-full h-full object-cover"
                  />
                </div>

                <div className="mb-4 absolute h-fit inset-0 bottom-0 md:top-[65%] top-3/4  text-center bg-purple-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-primary-purple-400 md:text-[24px] text-[12px]">
                    Seamless Curriculum Integration Prepare for exams in BECE,
                    WASSCE, NECO, JAMB and more!
                  </h3>
                </div>
              </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default TutorFeatureCarousel;
